import { render, staticRenderFns } from "./problem-form.vue?vue&type=template&id=9a12af74"
import script from "./problem-form.vue?vue&type=script&lang=js"
export * from "./problem-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports